import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Card } from '@comparethemarketau/manor-card';

import { List } from 'immutable';

import { withUnavailableBrands } from './common/with_unavailable_brands';
import { BrandNoReturnedTitle } from './common/brand_no_returned_title';
import { BrandNoReturnedReason } from './common/brand_no_returned_reason';

import { ProviderLogo } from '../products/common/provider_logo';
import { ContainerWrapper } from '../container_wrapper';

const useStyles = createUseStyles((theme) => ({
    card: {
        minHeight: '16.6rem',
        border: 'unset',
        display: 'block',
        margin: {
            bottom: theme.spacing[24]
        },
        padding: theme.spacing[12]
    },
    logo: {
        width: '6rem',
        height: '4.2rem',
        margin: 'auto'
    },
    title: {
        textAlign: 'center',
        margin: {
            top: theme.spacing[12],
            bottom: theme.spacing[24]
        }
    },
    reason: {
        textAlign: 'center'
    }
}));

const _UnavailableBrandsXs = (props) => {
    const { unavailableBrands, padding, availableQuotesSize } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        availableQuotesSize > 0 && (
            <ContainerWrapper padding={padding} className={classNames('test-unavailableBrands-xs')}>
                {unavailableBrands
            && (
                unavailableBrands.map((quote, index) => {
                    const providerName = quote.get('providerMeta').get('name');
                    const providerCode = quote.get('providerMeta').get('code');
                    return (
                        <div key={`unavailable-${providerCode}`} id={`unavailable-brand-row-${index}`} data-provider-id={providerCode}>
                            <Card
                                boxShadow
                                className={classes.card}
                            >
                                <ProviderLogo className={classes.logo} code={providerCode} />
                                <BrandNoReturnedTitle providerName={providerName} className={classes.title} />
                                <BrandNoReturnedReason className={classes.reason} />
                            </Card>
                        </div>

                    );
                })
            )}
            </ContainerWrapper>
        )
    );
};

_UnavailableBrandsXs.propTypes = {
    unavailableBrands: PropTypes.instanceOf(List),
    availableQuotesSize: PropTypes.number,
    padding: PropTypes.array
};

const UnavailableBrandsXs = withUnavailableBrands(_UnavailableBrandsXs);
export { UnavailableBrandsXs };
